export default __webpack_public_path__ + "static/media/video@1x.3244ac12.svg";